<template>




	<div class="content-i">
		<div class="content-box">
			<!--------------------
			 START - Breadcrumbs
			 -------------------->
			<ul class="breadcrumb">
				<li class="breadcrumb-item">
					<a href="index.html">Home</a>
				</li>
				<li class="breadcrumb-item">
					<a href="index.html">Products</a>
				</li>
				<li class="breadcrumb-item">
					<span>Laptop with retina screen</span>
				</li>
			</ul>
			<!--------------------
			END - Breadcrumbs
			-------------------->

			<div class="row mt-5">
				<div class="col-sm-12">
					<div class="element-wrapper">
						<div class="element-actions">
							<form class="form-inline justify-content-sm-end">
								<select class="form-control form-control-sm rounded">
									<option value="Pending">
										Today
									</option>
									<option value="Active">
										Last Week
									</option>
									<option value="Cancelled">
										Last 30 Days
									</option>
								</select>
							</form>
						</div>
						<h6 class="element-header">
							Sales Dashboard
						</h6>
						<div class="element-content">
							<div class="row">
								<div class="col-sm-4">
									<div class="element-box el-tablo">
										<div class="label">
											Products Sold
										</div>
										<div class="value">
											57
										</div>
										<div class="trending trending-up">
											<span>12%</span><i class="os-icon os-icon-arrow-up2"></i>
										</div>
									</div>
								</div>
								<div class="col-sm-4">
									<div class="element-box el-tablo">
										<div class="label">
											Gross Profit
										</div>
										<div class="value">
											$457
										</div>
										<div class="trending trending-down-basic">
											<span>12%</span><i class="os-icon os-icon-arrow-2-down"></i>
										</div>
									</div>
								</div>
								<div class="col-sm-4">
									<div class="element-box el-tablo">
										<div class="label">
											New Customers
										</div>
										<div class="value">
											125
										</div>
										<div class="trending trending-down-basic">
											<span>9%</span><i class="os-icon os-icon-graph-down"></i>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>

</template>

<script>
    import countTo from 'vue-count-to';

    export default {
        components: {countTo},
        name: 'admin',
        data () {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/Admin.vue